/** @format */
import isPropValid from '@emotion/is-prop-valid';
import {
    Button,
    ButtonVariant,
} from '@mpb-com/feather/components/atoms/button';
import React, { FunctionComponent, useState } from 'react';
import styled from 'styled-components';

import { Input, InputProps } from '@toucan/client/shared/components/input';

import { styles } from './password-input.styles';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type PasswordInputProps = InputProps & {
    showLabel: string;
    hideLabel: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    initialIsPasswordHidden?: boolean;
};

const blacklistedProps = ['name', 'label', 'value'];
const StyledPasswordInput = styled('div').withConfig({
    shouldForwardProp: (prop) =>
        isPropValid(prop) && !blacklistedProps.includes(prop),
})`
    ${styles}
`;

export const PasswordInput: FunctionComponent<PasswordInputProps> = ({
    showLabel,
    hideLabel,
    initialIsPasswordHidden = true,
    name,
    disabled,
    ...otherProps
}: PasswordInputProps) => {
    const [isPasswordHidden, setPasswordHidden] = useState<boolean>(
        initialIsPasswordHidden
    );

    function togglePasswordHidden() {
        setPasswordHidden(!isPasswordHidden);
    }

    return (
        <StyledPasswordInput
            showLabel={showLabel}
            hideLabel={hideLabel}
            name={name}
            disabled={disabled}
            {...otherProps}
        >
            <Input
                name={name}
                disabled={disabled}
                {...otherProps}
                type={isPasswordHidden ? 'password' : 'text'}
                data-testid="password-input__input"
                className="password-input"
            />
            <Button
                className="toggle-button"
                data-testid="password-input__toggle-button"
                onClick={togglePasswordHidden}
                variant={ButtonVariant.GHOST}
                disableHoverStyle
                disabled={disabled}
            >
                {isPasswordHidden ? showLabel : hideLabel}
            </Button>
        </StyledPasswordInput>
    );
};
